import React from "react";
import { useNavigate } from "react-router-dom";

const SubscribeNowBanner = () => {
  const navigate = useNavigate();
  return (
    <div id="explore" className="relative p-20 bg-[rgb(234,126,93)]">
            <section className="grid grid-cols-1 md:grid-cols-2 items-center px-6 max-w-7xl mx-auto">
              {/* Left Content */}
              <div className="text-left">
                <h2 className="text-4xl font-bold text-white font-['EB_Garamond','Nunito','sans-serif']">
                  START LEARNING TODAY
                </h2>
                <p className="text-lg text-white mt-4">
                  Join Now for Exclusive Access
                </p>
              </div>

              {/* Right CTA Button */}
              <div className="flex justify-end items-center mt-8 md:mt-0">
                <button className="mt-2 font-bold text-white relative hover:bg-white hover:text-[rgb(234,126,93)] px-4 py-2 transition duration-300 after:content-[''] after:block after:h-[2px] after:w-full after:bg-white after:mt-1"
                onClick={() => navigate(`/membership-plan`)}>
                 SUBSCRIBE NOW
                </button>
              </div>
            </section>
          </div>
  );
};

export default SubscribeNowBanner;